(function () {
    'use strict';

    angular
        .module('skillsApp')
        .factory('tokenService', tokenService);

    var clientId = "m5JrGMI5o06-txVcG_nPPA2";

    function tokenService(callbackUrl, $q, $timeout, $http, logger, $window, $location, $state, useLegacyOAuthClient) {
        callbackUrl = callbackUrl || getOrigin() + "/content/callback.html";

        var oauthFrame, mgr, redirectPromise;
        var refreshSetup = false;
        
        $window.sessionStorage.removeItem('accessToken');

        if (useLegacyOAuthClient) {
            return {
                getToken: getTokenLegacyOAuth
            };
        } else {

            // Oidc.Log.logger = console;
            // Oidc.Log.level = Oidc.Log.DEBUG;

            mgr = new Oidc.UserManager({
                authority: 'https://sts.competence.biz/identity',
                client_id: getClientId(),
                response_type: 'id_token token',
                redirect_uri: getRedirectUri(),
                scope: 'openid api name idString tcg_claims api_tcg_claims',
                automaticSilentRenew: true,
                loadUserInfo: false,
                includeIdTokenInSilentRenew: false,
                silent_redirect_uri: getOrigin() + '/skills/oidc-silent-callback'
            });

            return {
                getToken: getTokenOidc,
                oidcCallback: oidcCallback,
                oidcCallbackSilent: oidcCallbackSilent
            };
        }

        function getRedirectUri() {
            return getOrigin() + '/skills/oidc-callback';
        }

        function getOrigin() {
            return $window.location.origin ? $window.location.origin : $window.location.protocol + "//" + $window.location.hostname + ($window.location.port ? ':' + $window.location.port : ''); 
        }

        function getClientId() {
            switch ($window.location.hostname) {
                case "localhost":
                    return "https://develop.tcg-academy.nl";
                default:
                    return `https://${$window.location.hostname}`;
            }
        }

        function getTokenOidc() {

            return mgr.getUser().then(user => {
                if (user && !user.expired) {
                    //logger.log('mgr.getUser: User found and not Expired!');

                    $http.defaults.headers.common.Authorization = "Bearer " + user.access_token;
                    return $q.when(user.access_token);
                }

                logger.log('mgr.getUser: User NOT found OR Expired!');

                if (redirectPromise) {
                    logger.log('Promise found! Swallowing since we are already redirecting to STS...');
                    return redirectPromise;
                }

                logger.log('Redirecting to STS!');

                let state = {
                    pathname: $window.location.pathname,
                    search: $window.location.search
                };
                
                redirectPromise = mgr.signinRedirect({ state: state });
                return redirectPromise.then(() => $q.reject());
            });
        }

        function oidcCallback() {
            
            return mgr.signinRedirectCallback().then(x => {

                const state = x.state;
                
                if (!state || !state.pathname) {
                    logger.log('mgr.signinRedirectCallback: signin state not present');
                    return $q.reject('signin state not present');
                }

                logger.log('mgr.signinRedirectCallback: Redirecting back to calling page from state...');
                
                $window.location.href = state.pathname + (state.search ? state.search : '');
                return $q.when();
            }, err => {
                logger.toExceptionless(err, { 'href': $window.location.href }, 'oidc-callback', 'error');

                if (err.message.indexOf('iat is in the future') === 0 || err.message.indexOf('exp is in the past') === 0)
                {
                    return $state.go('error', {
                        error: {
                            message: 'error_device_time_problem'
                        }
                    });

                }

                let state = {
                    pathname: $window.location.pathname,
                    search: $window.location.search
                };

                return mgr.signinRedirect({ state: state });
            });
        }

        function oidcCallbackSilent() {
            return mgr.signinSilentCallback().then(x => {
                logger.log('mgr.signinSilentCallback successful');
            }, err => {
                logger.toExceptionless(err, { 'href': $window.location.href }, 'oidc-silent-callback', 'error');
            });
        }

        function getTokenLegacyOAuth() {
            var deferred = $q.defer();

            $window.addEventListener("message", handleTokenMessage, false);
                        
            var deadline = new Date().getTime() + 30000;
            var tokenExpires = parseInt($window.sessionStorage.accessTokenExpires, 10);

            if ($window.sessionStorage.accessToken && tokenExpires > deadline) {
                setupRefresh(tokenExpires - deadline);
                
                $http.defaults.headers.common.Authorization = "Bearer " + $window.sessionStorage.accessToken;

                deferred.resolve($window.sessionStorage.accessToken);
                return deferred.promise;
            }
            
            var hash = $location.hash();
            
            if (hash) {
                var token = parseToken(hash);
                $location.hash("");
                deferred.resolve(token);
                return deferred.promise;
            }

            deferred.reject();

            var redirectUri = encodeURIComponent($window.location.href);
            $window.location = "https://oauth.competence.biz/o/oauth2/auth?response_type=token&client_id=" + clientId + "&redirect_uri=" + redirectUri + "&scope=&prompt=login";

            return deferred.promise;
        }

        function handleTokenMessage(event) {
            logger.log('message', event);
            if (event.origin === $window.location.protocol + "//" + $window.location.host && oauthFrame) {
                logger.log('parse token and remove token refresh frame');
                parseToken(event.data);
                oauthFrame.remove();
                oauthFrame = null;
            }
        }
        
        function setupRefresh(when) {
            if (refreshSetup) return;
            refreshSetup = true;
            logger.log('create token refesh frame in ' + when + 'ms');
            $timeout(function () {
                refreshSetup = false;

                if (!oauthFrame) {
                    logger.log("create token refresh frame");
                    var redirectUri = encodeURIComponent(callbackUrl);
                    var iframeSrc = "https://oauth.competence.biz/o/oauth2/auth?response_type=token&client_id=" + clientId + "&redirect_uri=" + redirectUri + "&scope=&prompt=none";
                    oauthFrame = $("<iframe />");
                    oauthFrame.hide();

                    $(document.body).append(oauthFrame);
                    oauthFrame.attr("src", iframeSrc);
                }
            }, when);
        }

        function parseToken(hash) {
            var token, expires, expiresIn, expireTimeout;
            var responseParts = hash.substring(1).split("&");
            
            for (var i = 0; i < responseParts.length; i++) {
                var keyValue = responseParts[i].split("=");
                switch (keyValue[0]) {
                    case "access_token":
                        token = keyValue[1];
                        break;
                    case "expires_in":
                        expiresIn = parseInt(keyValue[1], 10);
                        var now = new Date().getTime();
                        expireTimeout = 1000 * expiresIn;
                        now += expireTimeout;
                        expires = now;
                        break;
                }
            }

            $window.sessionStorage.accessToken = token;
            $window.sessionStorage.accessTokenExpires = expires;
            $window.sessionStorage.accessTokenExpireTimeout = expireTimeout;

            $http.defaults.headers.common.Authorization = "Bearer " + token;

            setupRefresh(parseInt($window.sessionStorage.accessTokenExpireTimeout) - 30000);

            return token;
        }
    }
})();